export default __webpack_public_path__ + "static/3-0ca572480bbac072715cc6241589659e.png";